import { c as _c } from "react-compiler-runtime";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import * as React from "react";
import { useButton } from "react-aria";
import { Group } from "react-aria-components";
import { Plus } from "../icons/solid.js";
import { Avatar, Counter as AvatarCounter } from "./Avatar.js";
import * as styles from "./AvatarGroup.css.js";
import { Button } from "./Button.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseAvatarGroup = (t0, ref) => {
  const $ = _c(34);
  const {
    size,
    avatars,
    maxAvatarsPerRow,
    overflowAfter: t1,
    overflowTooltip,
    onPressAvatars,
    onPressAddMore,
    avatarsAriaLabel,
    avatarsAriaLabelledBy
  } = t0;
  const overflowAfter = t1 === undefined ? 1000000 : t1;
  const avatarsToRender = avatars.slice(0, overflowAfter);
  const overflow = avatars.length - overflowAfter;
  const avatarsRef = React.useRef(null);
  let t2;
  if ($[0] !== onPressAvatars) {
    t2 = {
      onPress: onPressAvatars
    };
    $[0] = onPressAvatars;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    buttonProps
  } = useButton(t2, avatarsRef);
  const isPressable = onPressAvatars != null;
  const hasOverflow = overflow > 0;
  const avatarsPerRow = getAvatarsPerRow(maxAvatarsPerRow, avatarsToRender.length, hasOverflow).toString();
  const T0 = Group;
  let t3;
  if ($[2] !== size) {
    t3 = styles.avatarGroup({
      size
    });
    $[2] = size;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== buttonProps || $[5] !== isPressable) {
    t4 = isPressable ? buttonProps : {};
    $[4] = buttonProps;
    $[5] = isPressable;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = assignInlineVars({
    [styles.avatarsPerRow]: avatarsPerRow
  });
  let t6;
  if ($[7] !== isPressable || $[8] !== size) {
    t6 = styles.avatars({
      isPressable,
      size
    });
    $[7] = isPressable;
    $[8] = size;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== size) {
    t7 = (avatar, index) => /*#__PURE__*/_jsx(Avatar, {
      size: size,
      ...avatar
    }, index);
    $[10] = size;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = avatarsToRender.map(t7);
  let t9;
  if ($[12] !== hasOverflow || $[13] !== overflow || $[14] !== overflowTooltip || $[15] !== size) {
    t9 = hasOverflow && /*#__PURE__*/_jsx(AvatarCounter, {
      tooltip: overflowTooltip?.(overflow) ?? false,
      size: size,
      count: overflow
    });
    $[12] = hasOverflow;
    $[13] = overflow;
    $[14] = overflowTooltip;
    $[15] = size;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== avatarsAriaLabel || $[18] !== avatarsAriaLabelledBy || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t8 || $[23] !== t9) {
    t10 = /*#__PURE__*/_jsxs("div", {
      ref: avatarsRef,
      ...t4,
      style: t5,
      "aria-label": avatarsAriaLabel,
      "aria-labelledby": avatarsAriaLabelledBy,
      className: t6,
      children: [t8, t9]
    });
    $[17] = avatarsAriaLabel;
    $[18] = avatarsAriaLabelledBy;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== onPressAddMore || $[26] !== size) {
    t11 = onPressAddMore && /*#__PURE__*/_jsx(Button, {
      onPress: onPressAddMore,
      hierarchy: "avatarAdd",
      size: size,
      leadingIcon: Plus,
      variant: "iconOnly"
    });
    $[25] = onPressAddMore;
    $[26] = size;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== T0 || $[29] !== ref || $[30] !== t10 || $[31] !== t11 || $[32] !== t3) {
    t12 = /*#__PURE__*/_jsxs(T0, {
      className: t3,
      ref: ref,
      children: [t10, t11]
    });
    $[28] = T0;
    $[29] = ref;
    $[30] = t10;
    $[31] = t11;
    $[32] = t3;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};
export const AvatarGroup = /*#__PURE__*/React.forwardRef(BaseAvatarGroup);
function getAvatarsPerRow(maxAvatarsPerRow, avatarsToRender, hasOverflow) {
  const overflowValue = hasOverflow ? 1 : 0;
  const avatarsToRenderPlusOverflow = avatarsToRender + overflowValue;
  if (maxAvatarsPerRow == null) {
    return avatarsToRenderPlusOverflow;
  }
  const avatarsPerRowPlusOverflow = maxAvatarsPerRow + overflowValue;
  return Math.min(avatarsToRenderPlusOverflow, avatarsPerRowPlusOverflow);
}
//# sourceMappingURL=AvatarGroup.js.map